import { render, staticRenderFns } from "./NotAllowed.vue?vue&type=template&id=88fb5f6c&scoped=true&lang=pug"
import script from "./NotAllowed.vue?vue&type=script&lang=ts"
export * from "./NotAllowed.vue?vue&type=script&lang=ts"
import style0 from "./NotAllowed.vue?vue&type=style&index=0&id=88fb5f6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fb5f6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VContainer,VImg})
